import { GovernanceDecisionValue } from './constants.js';
import { hasCompleteSatisfiedPredicateVector, REQUIRED_TRUE_PREDICATES } from './predicates.js';

export function evaluateGovernance(request, { requestedDecision = GovernanceDecisionValue.DENY, governanceToken = null, signer = null, rationale = '' } = {}) {
  if (!rationale.trim()) throw new Error('GOVERNANCE_RATIONALE_REQUIRED');
  if (!Object.values(GovernanceDecisionValue).includes(requestedDecision)) throw new Error('GOVERNANCE_DECISION_INVALID');
  const p = request.predicateResults || {};
  let decision = requestedDecision;
  const reasonCodes = [];
  if (p.provenanceComplete === false || p.contradictionFree === false) {
    decision = GovernanceDecisionValue.QUARANTINE;
    reasonCodes.push(p.provenanceComplete === false ? 'PROVENANCE_INCOMPLETE' : 'CONTRADICTORY_EVIDENCE');
  } else if (requestedDecision === GovernanceDecisionValue.ALLOW && !REQUIRED_TRUE_PREDICATES.every((key) => Object.hasOwn(p, key))) {
    throw new Error('GOVERNANCE_PREDICATE_VECTOR_INCOMPLETE');
  } else if (requestedDecision === GovernanceDecisionValue.ALLOW && !hasCompleteSatisfiedPredicateVector(p)) {
    decision = GovernanceDecisionValue.DENY;
    reasonCodes.push('PREDICATES_NOT_SATISFIED');
  }
  if (decision === GovernanceDecisionValue.ALLOW && !governanceToken) throw new Error('GOVERNANCE_TOKEN_REQUIRED');
  if (decision === GovernanceDecisionValue.ALLOW && !signer) throw new Error('GOVERNANCE_SIGNER_REQUIRED');
  return Object.freeze({
    decisionId: `decision-${request.requestId}`, requestId: request.requestId, decision,
    governanceToken: decision === GovernanceDecisionValue.ALLOW ? governanceToken : null,
    reasonCodes: Object.freeze(reasonCodes), rationale, signer: decision === GovernanceDecisionValue.ALLOW ? signer : null,
    timestamp: request.requestedAt
  });
}
